import React from 'react';
import NumberFormat from 'react-number-format';
import uniqid from 'uniqid';
import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : '',
            uid: detail ? detail.uid : uniqid(),
            depPlace: { name: 'depPlace', value: '', error: '', isRequired: true },
            depDate: { name: 'depDate', value: '', error: '', isRequired: true },
            depTime: { name: 'depTime', value: '', error: '', isRequired: true },

            arrPlace: { name: 'arrPlace', value: '', error: '', isRequired: true },
            arrDate: { name: 'arrDate', value: '', error: '', isRequired: true },
            arrTime: { name: 'arrTime', value: '', error: '', isRequired: true },

            modeOfConveyance: { name: 'modeOfConveyance', value: '', error: '', isRequired: true },
            totalKM: { name: 'totalKM', value: '', error: '', isRequired: true },
            rate: { name: 'rate', value: '', error: '', isRequired: true },
            vehicleNumber: { name: 'vehicleNumber', value: '', error: '', isRequired: true },
            amount: { name: 'amount', value: '', error: '', isRequired: true },
            // bills: { name: 'bills', value: [], error: '', isRequired: false },
        }
    }

    render() {
        const { depPlace, depDate, depTime, arrPlace, arrDate, arrTime, modeOfConveyance, totalKM, rate, vehicleNumber, amount } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Departure place <small>*</small></label>
                                        <input
                                            type="text"
                                            className={depPlace.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={depPlace.name}
                                            value={depPlace.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Departure date <small>*</small></label>
                                        <input
                                            type="date"
                                            className={depDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={depDate.name}
                                            value={depDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Departure time <small>*</small></label>
                                        <input
                                            type="time"
                                            className={depTime.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={depTime.name}
                                            value={depTime.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Arrival place <small>*</small></label>
                                        <input
                                            type="text"
                                            className={arrPlace.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={arrPlace.name}
                                            value={arrPlace.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Arrival date <small>*</small></label>
                                        <input
                                            type="date"
                                            className={arrDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={arrDate.name}
                                            value={arrDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Arrival time <small>*</small></label>
                                        <input
                                            type="time"
                                            className={arrTime.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={arrTime.name}
                                            value={arrTime.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Mode of journey <small>*</small></label>
                                        <input
                                            type="text"
                                            className={modeOfConveyance.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={modeOfConveyance.name}
                                            value={modeOfConveyance.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Vehicle number <small>*</small></label>
                                        <input
                                            type="text"
                                            className={vehicleNumber.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={vehicleNumber.name}
                                            value={vehicleNumber.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Total KM<small>*</small></label>
                                        <NumberFormat
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            allowNegative={false}
                                            className={totalKM.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={totalKM.name}
                                            value={totalKM.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: totalKM.name, value: e.value } }) }}
                                        />

                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Rate <small>*</small></label>
                                        <input
                                            type="text"
                                            className={rate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={rate.name}
                                            value={rate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Amount <small>*</small></label>
                                        <NumberFormat
                                            decimalScale={2}
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            className={amount.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={amount.name}
                                            value={amount.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: amount.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Bill(s) <sup>(optional)</sup></label>
                                        <input
                                            name={bills.name}
                                            onChange={this.onChange}
                                            type="file"
                                            multiple={true}
                                            className="form-control"
                                            style={{ padding: 4 }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        {
                                            Array.from(bills.value).map(function (item: any, index: number) {
                                                return (
                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div> */}

                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                id: st.id,
                uid: st.uid,
                depPlace: st.depPlace.value,
                depDate: st.depDate.value,
                depTime: st.depTime.value,

                arrPlace: st.arrPlace.value,
                arrDate: st.arrDate.value,
                arrTime: st.arrTime.value,

                modeOfConveyance: st.modeOfConveyance.value,

                totalKM: parseFloat(st.totalKM.value),
                rate: parseFloat(st.rate.value),
                vehicleNumber: st.vehicleNumber.value,
                amount: parseFloat(st.amount.value),
                // bills: st.bills.value
            };
            if (st.id === "") {
                model.id = new Date().getTime();
            }
            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;